import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { JsonLd } from "./JsonLd";
import { safeHtml } from "../lib/sanitize";

/** Accessible accordion FAQ + FAQPage JSON-LD in one component.
 *  items: [{ q: "Question?", a: "<p>Answer HTML or plain text</p>" }] */
export const FaqSection = ({ title = "Questions fréquentes", items }) => {
  const [open, setOpen] = useState(0);
  if (!items || !items.length) return null;
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map(it => ({
      "@type": "Question",
      "name": it.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": (it.a || "").replace(/<[^>]+>/g, ""),
      },
    })),
  };
  return (
    <section className="max-w-3xl mx-auto px-6 py-14" data-testid="faq-section">
      <JsonLd data={schema} />
      <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--accent)] mb-3 text-center">FAQ</div>
      <h2 className="font-display text-4xl sm:text-5xl text-center mb-10">{title}</h2>
      <div className="divide-y divide-[color:var(--border)] border-y border-[color:var(--border)]">
        {items.map((it, i) => {
          const isOpen = open === i;
          const itemKey = it.q || `faq-${i}`;
          return (
            <div key={itemKey} data-testid={`faq-item-${i}`}>
              <button
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 py-5 text-left hover:text-[color:var(--accent)] transition-colors"
                aria-expanded={isOpen}
              >
                <span className="font-display text-lg sm:text-xl">{it.q}</span>
                <ChevronDown className={`w-5 h-5 shrink-0 transition-transform ${isOpen ? 'rotate-180 text-[color:var(--accent)]' : ''}`} />
              </button>
              {isOpen && (
                <div
                  className="pb-5 text-sm text-[color:var(--text-muted)] leading-relaxed max-w-2xl"
                  dangerouslySetInnerHTML={safeHtml(it.a)}
                />
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};
